import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';

angular
  .module('flowingly.runner.library')
  .controller('procedureCopyDialogController', procedureCopyDialogController);

procedureCopyDialogController.$inject = ['$scope', 'procedureApiService'];

function procedureCopyDialogController(
  $scope: IScopeNgDialog,
  procedureApiService: SharedAngular.ProcedureApiService
) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const ctrl = this as {
    existingProcedureId: Guid;
    existingProcedureName: string;
    isRequestPending: boolean;
    newProcedureName: string;
    createCopy: () => angular.IPromise<void>;
    cancel: () => void;
  };
  ctrl.newProcedureName = '';
  ctrl.existingProcedureId = $scope.ngDialogData.existingProcedureId;
  ctrl.existingProcedureName = $scope.ngDialogData.existingProcedureName;

  ctrl.createCopy = () => {
    ctrl.isRequestPending = true;
    return procedureApiService
      .copyProcedure(ctrl.existingProcedureId, ctrl.newProcedureName)
      .then((newProcedureId) => {
        $scope.closeThisDialog({
          name: ctrl.newProcedureName,
          id: newProcedureId
        } as ICopyProcedureResult);
      })
      .catch(() => {
        ctrl.isRequestPending = false;
      });
  };

  ctrl.cancel = () => {
    $scope.closeThisDialog();
  };
}

export interface ICopyProcedureResult {
  name: string;
  id: Guid;
}
